export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11743.cfe87a2a.jpg";